import { HelpCircle } from "lucide-react";

interface Props {
  onClick: () => void;
}

export function HelpButton({ onClick }: Props) {
  return (
    <button
      onClick={onClick}
      aria-label="Abrir guía de inicio rápido"
      title="Guía de inicio rápido"
      className="flex h-9 w-9 items-center justify-center rounded-full glass transition hover:bg-accent"
    >
      <HelpCircle className="h-4 w-4" />
    </button>
  );
}